import React, { useState } from "react";
import editicon from "../../Images/editicon.png";
import facebook_icon from "../../Images/facebook_icon.png";
import insta_icon from "../../Images/insta_icon.png";
import linkedin_icon from "../../Images/linkedin_icon.png";
import Editsocilamediamodal from "../../Modal/Editsocilamediamodal";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
const Socilallinkprofile = ({ updateForm, data,setIsUpdate }) => {
  const { UserProfileID } = useSelector((state) => state.app);
  const [editcsolisdmoidala, setEditcsolisdmoidala] = useState(false);
  const editsoicilksaincclick = () => {
    setEditcsolisdmoidala(!editcsolisdmoidala);
  };
  
  return (
    <>
      <div className="uploadbannerblmdiv">
        <div className="uploadbannerdivnewmain">
          <div className="consttactdetatlsarroedyrdiv">
            <p className="cinnattddttdtsttspo">Social links</p>
            {
              UserProfileID?._id === data?._id &&
              <div className="editeiconimg" onClick={editsoicilksaincclick}>
                <img src={editicon} alt="..." />
              </div>
            }

          </div>
          <div className="fallsebblldivmaindivflxl">
            <div className="fallsebblldivmain">
              <div className="icopndibimahhmainimjh">
                <a href={data?.businessFacebookLink} target="_blank"><img src={facebook_icon} alt="..." /></a>
              </div>
              <p className="faccevttxttpphhtxtpp">Facebook </p>

            </div>
            <div className="fallsebblldivmain">
              <div className="icopndibimahhmainimjh">
                <a href={data?.businessInstaLink} target="_blank"><img src={insta_icon} alt="..." /></a>
              </div>
              <p className="faccevttxttpphhtxtpp">Instagram</p>
            </div>
            <div className="fallsebblldivmain">
              <div className="icopndibimahhmainimjh">
                <a href={data?.businessLinkedInLink} target="_blank"><img src={linkedin_icon} alt="..." /></a>
              </div>
              <p className="faccevttxttpphhtxtpp">Linkedin</p>
            </div>
          </div>
        </div>
      </div>

      {editcsolisdmoidala && (
        <Editsocilamediamodal
          updateForm={updateForm}
          data={data}
          closemodal={editsoicilksaincclick}
          setIsUpdate={setIsUpdate}
        />
      )}
    </>
  );
};

export default Socilallinkprofile;
